import { render, staticRenderFns } from "./drugsList.vue?vue&type=template&id=5f3cafd8&scoped=true&"
import script from "./drugsList.vue?vue&type=script&lang=js&"
export * from "./drugsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3cafd8",
  null
  
)

export default component.exports